import type { SsoUser } from '@domain/entities';
import type { IUserRepository } from '@domain/repositories';
import type { PaginatedResult, UserFilters } from '@application/dto';

export class ListUsersUseCase {
  constructor(private readonly userRepository: IUserRepository) {}

  async execute(filters: UserFilters): Promise<PaginatedResult<SsoUser>> {
    return this.userRepository.list(filters);
  }
}
